
import React from 'react';
import { Student, SortField, SortOrder } from '@/hooks/useStudentList';
import { StudentSearch, StudentTable, StudentPagination } from './student-list';

interface StudentListProps {
  students: Student[];
  isLoading: boolean;
  currentPage: number;
  totalPages: number;
  searchQuery: string;
  sortField: SortField;
  sortOrder: SortOrder;
  onSearch: (query: string) => void;
  onPageChange: (page: number) => void;
  onSort: (field: SortField) => void;
}

export const StudentList: React.FC<StudentListProps> = ({
  students,
  isLoading,
  currentPage,
  totalPages,
  searchQuery,
  sortField,
  sortOrder,
  onSearch,
  onPageChange,
  onSort,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center">
        <StudentSearch searchQuery={searchQuery} onSearch={onSearch} />
      </div>

      <StudentTable 
        students={students} 
        isLoading={isLoading} 
        sortField={sortField}
        sortOrder={sortOrder}
        onSort={onSort}
      />

      {totalPages > 0 && (
        <StudentPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};
